import React, { useState, useEffect, Fragment } from 'react'
import "../My-Questions/myQuestions.scss";
import { useDispatch } from 'react-redux';
import { deleteCodingQuestion, getCodingQuestionLanguages, getCodingQuestions, getQuestionLevels, resetCodingQuestions, resetQuestion, resetQuestions, setQuestionValues } from '../../Redux/ActionCreators/testLibraryAction';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { Table } from 'react-bootstrap';
import ConfirmModal from '../../utils/confirmModal';
import { useNavigate } from 'react-router-dom';

export default function MyTechnicalQuestions() {
    const [language, setLanguage] = useState(null);
    const [level, setLevel] = useState(null);
    const [query, setQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [testsPerPage, setTestsPerPage] = useState(20);
    const [isConfirm, setIsConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchQuestions = async () => {
            setLoading(true);
            await dispatch(resetCodingQuestions());
            await dispatch(getCodingQuestionLanguages());
            await dispatch(getQuestionLevels());
            await dispatch(getCodingQuestions(1, 20, 0, 0, "", []));
            setLoading(false);
        };
        fetchQuestions();
    }, []);

    const { codingQuestionLanguagesOptions, questionLevel, codingQuestionListResponse, isQuestionLoading, total } = useSelector((state) => state.testLibrary);
    console.log('codingQuestionListResponse', codingQuestionListResponse);
    const onDeleteQuestionConfirmation = () => {
        removeConfirm();
    };

    const removeConfirm = async () => {
        if (!deleteId) return;
        let obj = {id: deleteId};
        setLoading(true);
        const res = await dispatch(deleteCodingQuestion(obj));
        if (res?.type === "DELETE_QUESTION") {
            setIsConfirm(false);
            setDeleteId("");
            setLoading(true);
            await dispatch(getCodingQuestions(currentPage, testsPerPage, level?.value || 0, language?.value || 0, query, []));
        }
        setLoading(false);
    };

    const deleteQues = (id) => {
        setDeleteId(id);
        setIsConfirm(true);
    };

    const openCreate = async () => {
        await dispatch(resetQuestion());
        await dispatch(resetQuestions());
        await dispatch(resetCodingQuestions());
        await dispatch(setQuestionValues({ question: null }));
        navigate("/create", {
          state: { edit: false, question: true, detail: null },
        });
    };

    const totalPages = Math.ceil(total / testsPerPage);
    
    const paginate = async (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        setLoading(true);
        await dispatch(getCodingQuestions(pageNumber, testsPerPage, level?.value || 0, language?.value || 0, query, []));
        setLoading(false);
    }

    const handlePageSizeChange = async (e) => {
        const size = parseInt(e.target.value);
        setTestsPerPage(size);
        setCurrentPage(1);
        setLoading(true);

        await dispatch(
            getCodingQuestions(
            1,
            size,
            level?.value || 0,
            language?.value || 0,
            query,
            []
            )
        );
        setLoading(false);
        };

    const Pagination = ({ currentPage, totalPages, paginate }) => {
        const getPageNumbers = () => {
            if (totalPages <= 4) {
            return Array.from({ length: totalPages }, (_, i) => i + 1);
            } else if (currentPage <= 3) {
            return [1, 2, 3, "...", totalPages];
            } else if (currentPage >= totalPages - 2) {
            return [1, "...", totalPages - 2, totalPages - 1, totalPages];
            } else {
            return [
                1,
                "...",
                currentPage - 1,
                currentPage,
                currentPage + 1,
                "...",
                totalPages,
            ];
        }
    };
      
    return (
        <div className="pagination">
            <div className='d-flex flex-wrap align-items-center' style={{gap:'40px'}}>
            <div className="pagination-info">
                {codingQuestionListResponse.length > 0 ? (
                <span>
                    Showing <strong>{(currentPage - 1) * testsPerPage + 1}</strong>-
                    <strong>
                    {(currentPage - 1) * testsPerPage + codingQuestionListResponse.length}
                    </strong>{" "}
                    of <strong>{total}</strong>
                </span>
                ) : (
                <span>Showing 0-0 of 0</span>
                )}
            </div>
            <div className="d-flex align-items-center">
                <span style={{ color: "#525B66" }}>Questions per page</span>
                &nbsp;&nbsp;
                <select
                    value={testsPerPage}
                    onChange={handlePageSizeChange}
                    style={{ width: "46px", height:'32px', borderRadius:'2px', color:'#8A9199' }}
                >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
                </div>
            </div>
            <div className="pagination-buttons">
                <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                >
                <img src="/images/leftarrow-icon.svg" alt="" />
                </button>
                {getPageNumbers().map((page, index) => (
                <button
                    key={index}
                    onClick={() => (page === "..." ? null : paginate(page))}
                    className={currentPage === page ? "active" : ""}
                    disabled={page === "..."}
                >
                    {page}
                </button>
                ))}
                <button
                onClick={() => paginate(currentPage + 1)}
                disabled={currentPage === totalPages || totalPages === 0}
                >
                <img
                    src="/images/leftarrow-icon.svg"
                    alt=""
                    style={{ rotate: "180deg" }}
                />
                </button>
            </div>
        </div>
        );
    };

    const editQuestion = async (el, view) => {
        await dispatch(resetQuestion());
        await dispatch(resetCodingQuestions());
        await dispatch(setQuestionValues(el));

        if (el?.questionTypeID === 12) {
            navigate("/create", {
            state: {
                detail: el,
                edit: true,
                question: true,
                view: view,
                questionTypeID: 12,
            },
            });
        } else if (el?.questionTypeID === 13) {
            navigate("/create", {
            state: {
                detail: el,
                edit: true,
                question: true,
                view: view,
                questionTypeID: 13,
            },
            });
        } else if (el?.questionTypeID === 7) {
            navigate("/create", {
            state: {
                detail: el,
                edit: true,
                question: true,
                view: view,
                questionTypeID: 7,
                version: el?.version
            },
            });
        } else {
            navigate("/create-coding-question", {
            state: { detail: el, edit: true, question: true, view: view, questionTypeID: el?.questionTypeID, },
            });
        }
        };

    const handleLanguageChange = async (e) => {
        setLanguage(e);
        setLoading(true);
        await dispatch(getCodingQuestions(1, 20, level?.value || 0, e?.value || 0, query, []));
        setLoading(false);
    }
    const handleLevelChange = async (e) => {
        setLevel(e);
        setLoading(true);
        await dispatch(getCodingQuestions(1, 20, e?.value || 0, language?.value || 0, query, []));
        setLoading(false);
    }

    const handleSearchChange = async (e) => {
        setQuery(e);
        setLoading(true);
        await dispatch(getCodingQuestions(1, 20, level?.value || 0, language?.value || 0, e, []));
        setLoading(false);
    }

    return (
        <div>
            <div className="my-search">
                <div className="row">
                    <div className="col-md-4">
                    <div>
                        <Select
                        isClearable
                        options={codingQuestionLanguagesOptions?.map(
                            (el) =>
                            [
                                {
                                label: el.displayLanguage,
                                value: el.id,
                                },
                            ][0]
                        )}
                        value={language}
                        placeholder="Select Language"
                        onChange={(e) => handleLanguageChange(e)}
                        />
                    </div>
                    </div>
                    <div className="col-md-4">
                    <div>
                        <Select
                        isClearable
                        options={questionLevel?.map(
                            (el) =>
                            [
                                {
                                label: el.questionLevelName,
                                value: el.questionLevelID,
                                },
                            ][0]
                        )}
                        value={level}
                        placeholder="Select Level"
                        onChange={(e) => handleLevelChange(e)}
                        />
                    </div>
                    </div>
                </div>
                <div
                className="search-test  mt-3 flex-wrap d-flex justify-content-between gap-1"
                style={{
                    alignItems: window.innerWidth < 767 ? "flex-start" : "center",
                    flexDirection: window.innerWidth < 767 && "column-reverse",
                }}
                >
                <div
                    className="has-search"
                    style={{ width: window.innerWidth > 767 ? "79%" : "100%" }}
                >
                    <span className="form-control-feedback">
                    <img src="/images/search.svg" alt="" width={12} />
                    </span>
                    <input
                    type="text"
                    className="form-control"
                    value={query}
                    placeholder="Search for Question"
                    onChange={(e) => handleSearchChange(e.target.value)}
                    />
                </div>
                <div style={{ width: window.innerWidth > 1000 ? "20%" : "100%" }}>
                    <button
                        style={{ width: "-webkit-fill-available" }}
                        onClick={() => openCreate()}
                    >
                        Create Question
                    </button>
                </div>
                </div>
            </div>
                <div className="table-admin">
                <Table responsive className="assessment-table">
                    <thead>
                    <tr>
                        <th className="text-left">Question</th>
                        <th className="text-left">Type</th>
                        <th className="text-left">Difficulty</th>
                        <th className="text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                {loading || isQuestionLoading ? (
                <tr>
                    <td colSpan="10">
                        <div className="loading-overlay" style={{alignItems:'start', color:'#F75891', height:'auto'}}>
                            <div className="spinner-border" role="status"><span className="visually-hidden">Loading technical questions...</span></div>
                        </div>
                    </td>
                </tr>
                ) : codingQuestionListResponse?.length > 0 ? (
                    codingQuestionListResponse &&
                        codingQuestionListResponse?.map((el) => {
                        return (
                            <tr key={el?.id || el?.questionID}>
                            {window.innerWidth > 767 ? (
                                <Fragment>
                                <td style={{ width: "50%" }}>
                                    <h5
                                    className="elipsis-2" 
                                    dangerouslySetInnerHTML={{
                                        __html: el?.name,
                                    }}
                                    />
                                </td>
                                <td style={{ width: "20%", textAlign: "left" }}>
                                    <div>
                                        <img
                                        src="/images/coding.svg"
                                        alt=""
                                        width={20}
                                        />
                                    <span> {el?.questionTypeName}</span>
                                    </div>
                                </td>
                                <td style={{ width: "15%", textAlign: "left" }}>
                                    <div>{el?.difficultyLevelName}</div>
                                </td>
                                <td style={{ width: "15%", textAlign: "left" }}>
                                    <div className="d-flex align-items-center" style={{gap:'8px'}}>
                                        <button className='question-btn' title="View" onClick={() => editQuestion(el, true)}><img src='/images/eye-black-icon.svg' alt='' width={18} height={18} /></button>
                                        <button className='question-btn' title="Edit" onClick={() => editQuestion(el, false)}><img src='/images/edit-black-icon.svg' alt='' width={18} height={18} /></button>
                                        <button className='question-btn' title="Delete" onClick={() => deleteQues(el.id)}><img src='/images/trash-bin-black.svg' alt='' width={18} height={18} /></button>
                                        {(() => {
                                            const canTry = Number(el?.questionTypeID) === 12 || Number(el?.version) === 2;

                                            return (
                                                <button
                                                className="question-btn"
                                                disabled={!canTry}
                                                title="Try this problem"
                                                style={{
                                                    backgroundColor: canTry ? "" : "#d3d3d3",
                                                    cursor: canTry ? "pointer" : "not-allowed",
                                                    opacity: canTry ? 1 : 0.6,
                                                }}
                                                onClick={() => {
                                                    if (!canTry) return;
                                                    window.open(`/try-coding/${el?.id}`, "_blank");
                                                }}
                                                >
                                                <img src='/images/laptop-black-icon.svg' alt='' width={18} height={18} />
                                                </button>
                                            );
                                        })()}
                                    </div>
                                </td>
                                </Fragment>
                            ) : (
                                <Fragment>
                                <td style={{ width: "75%" }}>
                                    <h5
                                    className="elipsis-2"
                                    dangerouslySetInnerHTML={{
                                        __html: el?.name,
                                    }}
                                    />
                                    <div className="d-flex justify-content-start mt-2">
                                        <img
                                        src="/images/coding.svg"
                                        alt=""
                                        width={20}
                                        />
                                    <span> {el?.questionTypeName}</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                    <button className='create' onClick={() => editQuestion(el, true)}>View</button>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                    <button className='create' onClick={() => editQuestion(el, false)}>Edit</button>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                    <button className='create' onClick={() => deleteQues(el.questionID)}>Delete</button>
                                    </div>
                                </td>
                                </Fragment>
                            )}
                            </tr>
                        );
                        })
                    ) : (
                    <tr>
                        <td colSpan="6">
                            <div className="empty-list">
                                <img src="/images/magnifier.svg" alt="" />
                                <div className="mt-2"><h3>No Questions added</h3></div>
                            </div>
                        </td>
                    </tr>
                )}
                </tbody>
            </Table>
            {!(loading || isQuestionLoading) && 
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                paginate={paginate}
            />
            }
            </div>
            <ConfirmModal
                isConfirm={isConfirm}
                setIsConfirm={() => setIsConfirm(false)}
                removeConfirm={onDeleteQuestionConfirmation}
            />
        </div>
    );
}